<template>
  <div class="contact-header">
    <AvatarImage :image-path="contact.photo_path"
                 :name="contact.full_name"
                 :color-id="contact.color_id"/>

    <div class="contact-title-wrapper">

      <v-tooltip top
                 content-class="name-tooltip">
        <template v-slot:activator="{ on, attrs }">
          <div class="contact-name"
               v-bind="attrs"
               v-on="on">
            {{contact.full_name}}
          </div>
        </template>
        <span>
            {{contact.full_name}}
        </span>
      </v-tooltip>

      <div class="contact-status-review-wrapper"
           v-if="contactStatus">

        <StatusIcon class="contact-status-icon"
                    :status="contactStatus.value"/>

        <div class="contact-status-value">
          {{contactStatus.display_value}}
        </div>

        <div class="contact-review"
             v-if="contact.review.score">
          <ul>
            <li class="review-separator">|</li>
            <li v-for="n in contact.review.score" :key="n">
              <VSvgIcon tag="10" size="10" icon="stars_full"/>
            </li>
          </ul>
        </div>

      </div>

    </div>

    <v-tooltip top
               content-class="edit-tooltip"
               :disabled="isMobile">
      <template v-slot:activator="{ on, attrs }">
        <v-icon class="edit-button"
                @click="handleEditButtonClick"
                v-bind="attrs"
                v-on="on">
          icon-pencil-s
        </v-icon>
      </template>
      <span>{{$t('common.words.edit')}}</span>
    </v-tooltip>

  </div>
</template>

<script>
  import { AvatarImage, VSvgIcon, StatusIcon } from "@/modules/common/components";
  import {mapGetters} from "vuex";

  export default {
    name: "ContactHeader",
    components: {AvatarImage, VSvgIcon, StatusIcon},
    props: {
      contact: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapGetters(['isMobile']),
      contactStatus() {
        return this.contact.data.find(field => field.field_type === 'status');
      }
    },
    methods: {
      handleEditButtonClick() {
        this.$frontageApi.send('matter_action', {action: 'edit_contact'});
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .contact-header {
    padding-bottom: 8px;

    .avatar-wrapper {
      @include i-float(left);
      border-radius: 50% !important;
      height: 38px;
      width: 38px;
      @include i-margin-mirror(0, 8px);
    }

    .contact-title-wrapper {
      font-size: 12px;
      display: inline-block;

      .contact-name {
        font-weight: 600;
        padding-bottom: 2px;
        width: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: default;
      }

      .contact-status-review-wrapper {

        .contact-status-icon {
          font-size: 11px;
          @include i-float(left);
          top: 3px;
          @include i-padding-mirror(0, 5px);
        }

        .contact-status-value {
          display: inline-block;
          color: $grey-color-6;
        }

        .contact-review {
          display: inline-block;

          .review-separator {
            color: $grey-color-2;
            padding: 0 5px;
          }

          ul {
            display: flex;
            padding: 0;

            li {
              list-style: none;
              padding: 0 1px;
            }
          }
        }
      }
    }

    .edit-button {
      @include i-float(right);
      font-size: 16px;
      top: 8px;
      @include i-position-mirror(right, 5px);
      height: 28px;
      width: 28px;
      position: absolute;
      color: $grey-color-5;
      border-radius: 50%;
      transition: color 0.2s, background-color 0.2s;

      .matter-page-wrapper &, .matter-pane-desktop & {

        &:hover {
          color: $navy-color-1;
          background-color: $grey-color-10;
        }
      }
    }
  }

  .name-tooltip {
    font-family: var(--primary-font-family);
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    z-index: 50 !important;
  }

  .edit-tooltip {
    font-family: var(--primary-font-family);
    font-size: 11px;
    line-height: 18px;
    margin-top: 5px;
    padding: 2px 10px;
    z-index: 50 !important;
  }
</style>
